var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from '../../styled';
import { RightIconSizeMap } from '../../themes/inputs';
import { Alert } from '../icons/solid';
import { StyledInput as InputComponent, InputWrapper, MessageWrapper, Message, RightIconWrapper, } from '../input';
import * as ClearButton from '../button/ClearButton';
const StyledInput = styled(InputComponent) `
  ${props => props.haveRightIcon &&
    css `
      padding-left: 0.75rem;
      padding-right: 2.5rem;
    `};

  ${props => props.haveErrorIcon &&
    css `
      padding-right: ${({ inputSize, theme }) => theme.inputs.size[inputSize].containerRightIconPadding};
    `};
`;
const ButtonWrapper = styled.div `
  padding: 0.0625rem 0.0625rem 0.0625rem 0;
  > button {
    border-radius: 0 5px 5px 0;
  }
`;
const StyledRightIconWrapper = styled(RightIconWrapper) `
  ${props => props.status === 'valid' &&
    css `
      padding: 0;
      > svg {
        * {
          fill: ${({ theme }) => theme.colors.SNOW_100};
        }
      }
    `}
`;
const StyledMessage = styled(Message) `
  font-size: 0.875rem;
  color: ${({ theme, status }) => status === 'invalid' ? theme.colors.RED_700 : theme.colors.GREEN_600};
`;
const InputWithCheck = (_a) => {
    var { disabled, status = 'valid', value, renderMessages, innerRef, block = false, Icon, inputSize = 'MEDIUM', onChange, onButtonClick, isShowRightIcon = false, isButtonDisabled = true, e2eInputId, e2eMessagesId } = _a, restProps = __rest(_a, ["disabled", "status", "value", "renderMessages", "innerRef", "block", "Icon", "inputSize", "onChange", "onButtonClick", "isShowRightIcon", "isButtonDisabled", "e2eInputId", "e2eMessagesId"]);
    const handleOnChange = (event) => {
        if (onChange) {
            onChange(event.target.value);
        }
    };
    return (React.createElement("div", null,
        React.createElement(InputWrapper, { "data-e2e-id": e2eInputId, block: block },
            React.createElement(StyledInput, Object.assign({}, restProps, { ref: innerRef, value: value, type: "input", status: status, disabled: disabled, inputSize: inputSize, block: block, haveRightIcon: !!Icon, haveErrorIcon: status === 'invalid', haveLeftIcon: false, onChange: handleOnChange })),
            React.createElement(StyledRightIconWrapper, { status: status, inputSize: inputSize }, status === 'invalid' ? (React.createElement(Alert, { size: RightIconSizeMap[inputSize] })) : (isShowRightIcon &&
                Icon && (React.createElement(ButtonWrapper, { inputSize: inputSize },
                React.createElement(ClearButton.Primary, { Icon: Icon, onClick: onButtonClick, disabled: isButtonDisabled })))))),
        renderMessages && (React.createElement(MessageWrapper, { "data-e2e-id": e2eMessagesId },
            React.createElement(StyledMessage, { status: status }, renderMessages())))));
};
export default React.forwardRef((props, ref) => React.createElement(InputWithCheck, Object.assign({ innerRef: ref }, props)));
//# sourceMappingURL=index.js.map